export default __webpack_public_path__ + "static/media/mars37.4de3a038.gif";